import React from 'react';
import { element, number, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { PriceDrop as PriceDropComponent } from '@thd-olt-component-react/thd-recs-containers';
import { Card, CardTitle } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from '../components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedPriceDrop({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
  REQUEST_KEY,

  brandTitleMaxLine,
  slidesPer,
}) {
  return (
    <QueryProvider cacheKey="pricedrop-recognized-homepage">
      <Hydrator
        id="priceDrop-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
      >
        <Card>
          <CardTitle
            className="card__title u-width-100"
            title="New Lower Prices on Your Items"
          />
          <PriceDropComponent
            hideTitle
            showFallback
            showLoading
            requestKey={REQUEST_KEY}
            brandTitleMaxLine={brandTitleMaxLine}
            slidesPer={slidesPer}
          />
        </Card>
      </Hydrator>
    </QueryProvider>
  );
}

CustomRenderedPriceDrop.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,
  REQUEST_KEY: string,

  brandTitleMaxLine: number,
  slidesPer: number,
};

CustomRenderedPriceDrop.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,
  REQUEST_KEY: undefined,

  brandTitleMaxLine: undefined,
  slidesPer: undefined,
};